import script from "./UserProfileBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./UserProfileBlock.vue?vue&type=script&setup=true&lang=js"

import "./UserProfileBlock.vue?vue&type=style&index=0&id=5b9493ba&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/ignis-pha-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b9493ba"]])

export default __exports__